import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { WiseRecipientStatusEnum } from './wise.recipient.status.enum';

export const WiseRecipientSchema = WithBaseEntitySchema(
    z.object({
        recipientId: z.string(),
        profileId: z.string(),
        status: EnumSchema(WiseRecipientStatusEnum).optional(),
        bankAccount: z.string().optional(),
        currency: EnumSchema(Currency).optional(),
    }),
).strict();

export class WiseRecipient extends FromSchema(WiseRecipientSchema) implements BaseEntity {
    id: string;
    recipientId: string;
    profileId: string;
    bankAccount: string;
    currency: Currency;

    status?: WiseRecipientStatusEnum;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
